import React from 'react';
import { Row, Col, Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Content } from './style';

const Subscription = () => (
  <Content>
    <Container>
      <Row>
        <Col sm={{ size: 12 }} md={{ size: 8, offset: 2 }} lg={{ size: 6, offset: 3 }}>
          <h1>Os principais jornais do Brasil ao alcance de suas mãos</h1>
          <p>Apenas R$14,99/mês</p>
          <div className="action-link">
            <Link to="/signup?subscriprion=go" class="btn btn-default">
              Assine agora
            </Link>
          </div>
          {/* <small>Cancele quando quiser.</small> */}
        </Col>
      </Row>
    </Container>
  </Content>
);

export default Subscription;



// WEBPACK FOOTER //
// ./src/pages/lps/subscription/index.js